var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-list"},_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"select-item",class:{
      'is-active':
        typeof _vm.value === 'string'
          ? _vm.value === (typeof item === 'string' ? item : item[_vm.valueKey])
          : _vm.value.includes(typeof item === 'string' ? item : item[_vm.valueKey]),
    },on:{"click":function($event){return _vm.clickItem(item)}}},[_vm._v(" "+_vm._s(typeof item === "string" ? item : item[_vm.valueLabel])+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }